import {
  Component, ChangeDetectionStrategy, ViewEncapsulation,
} from '@angular/core';
import { SharedService } from '@shared/services/shared.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-footer',
  host: {
    class: 'matero-header',
  },
  templateUrl: './footer.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {

  public environment = environment;
  
  constructor(
    public sharedService: SharedService
  ) { }

  // gotoPage(page: string) {
  //   this.sharedService.doRedirect(page);
  // }
}
